import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueEasyLightbox from "vue-easy-lightbox";
import "vue-easy-lightbox/dist/external-css/vue-easy-lightbox.es5.esm.min.js";
import "bootstrap/scss/bootstrap.scss";
import "swiper/css/bundle";
import "./assets/fonts/flaticon.css";
// import "bootstrap";
import BootstrapVue3 from "bootstrap-vue-3";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "./assets/scss/main.scss";
import store from "./store";
import axiosSetup from "@/axios-instances";
import ToastPlugin from "vue-toast-notification";
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import "vue-toast-notification/dist/theme-bootstrap.css";
import VueFeather from "vue-feather";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import "@bhplugin/vue3-datatable/dist/style.css";
import { VueSelect } from "vue-select";

const app = createApp(App);
app.use(router);
app.component(VueFeather.name, VueFeather);
app.component("VueDatePicker", VueDatePicker);
app.component("Vue3Datatable", Vue3Datatable);
app.component("v-select", VueSelect);
app.use(store);
app.use(axiosSetup);
app.use(BootstrapVue3);
app.use(ToastPlugin);
app.use(VueEasyLightbox);
app.mount("#app");
